import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=5e93030b&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "./phone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\sacha\\dotnet\\ChoupsBooking\\src\\Satrabel.ChoupsBooking\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e93030b', component.options)
    } else {
      api.reload('5e93030b', component.options)
    }
    module.hot.accept("./phone.vue?vue&type=template&id=5e93030b&", function () {
      api.rerender('5e93030b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/shared/phone.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./ClientApp/shared/phone.vue
// module id = 24
// module chunks = 2 5